export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "ko",
    "resource": {
      "Forgot your password?": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["비밀번호를 잊어버렸나요??"])},
      "Forgot your ID?": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["아이디 찾기"])}
    }
  })
}
